import { render, staticRenderFns } from "./RegisterResult.vue?vue&type=template&id=7e2ee032&scoped=true&"
import script from "./RegisterResult.vue?vue&type=script&lang=js&"
export * from "./RegisterResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2ee032",
  null
  
)

export default component.exports